var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cargo-ag-grid-wrapper", {
    class:
      "dw-ag-grid" +
      (_vm.finalRowData.length > 150 ? " loanding-renderer" : ""),
    attrs: {
      "config-module": _vm.columnDefs.length > 0 ? _vm.configModule : "",
      "grid-options": _vm.gridOptions,
      "column-defs": _vm.columnDefs,
      "row-data": _vm.finalRowData,
      "show-row-groups": true,
      "filter-menu-items": _vm.filterMenuItems,
      "row-group-default-collapse": true
    },
    on: {
      "sort-changed": _vm.onSortChanged,
      columnRowGroupChanged: _vm.onColumnRowGroupChanged
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }